import React from 'react'
import { FaStar } from 'react-icons/fa'

const reviews = [
  {
    name: 'Vedant Vishal Trivedi',
    institution: 'SNJB\'S Late Sau K.B.Jain College of Engineering',
    stars: 5,
    comment: 'The session was worth the money. It was the right decision to register for business analytics. I learnt many concepts and sharpened my skills.'
  },
  {
    name: 'Sneha Sharma',
    institution: 'Satyawati College Delhi University, BA',
    stars: 4,
    comment: 'I got to learn so much from this internship. Business analytics is a totally new domain for me, and InternsElite made it very easy for me to learn and grow in this field. Teachers are also very friendly, and their way of teaching is excellent.'
  },
  {
    name: 'Koustav Mandal',
    institution: 'Institute of Engineering and Management, IT',
    stars: 5,
    comment: 'This program has empowered me with valuable skills, ethical awareness, and practical experience in the field of Data Science and Business Analytics. I am grateful for this opportunity and excited to apply my knowledge in future endeavors.'
  },
  {
    name: 'Ritul Mishra',
    institution: 'SKN Sinhgad Institute of Technology and Science Lonavala, IT',
    stars: 4,
    comment: 'Overall, the session was very interactive and awesome. Practical experience is one of the primary benefits of this internship and training. You get to apply what you\'ve learned in a real-world setting, gaining valuable skills and knowledge.'
  },
  {
    name: 'Hitesh Kumar',
    institution: 'NIT, Kurukshetra and Computer Applications',
    stars: 5,
    comment: 'This program provided a valuable learning experience, encompassing various projects and equipping me with skills in Python, data analytics, Tableau, and machine learning. Special thanks to Instructors Dhawani Maam and Kiran Maam, and to InternsElite for this opportunity.'
  },
  {
    name: 'Harshvardhan Ashok Jadhav',
    institution: 'Indian Institute of Management Bodhgaya, IPM',
    stars: 4,
    comment: 'It was a very good experience for me. I really enjoyed my internship and training. I got to learn many things from the mentor which I was not aware of. I found my interest in business analytics.'
  }
];

function BA_Review_Program_Page() {
  return (
    <div>
      <div className='container'>
        <div className='row d-sm-block d-md-none'>
          <div className='col-md-1'></div>
          <div className='col-md-10'>
            <div className='text-center review_component_text'>
              <h2 className='display-5 pb-2'>Testimonial</h2>
              <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
            </div>
          </div>
          <div className='col-md-1'></div>
        </div>
        <div className='row'>
          <div className='col-md-4 pt-5'>
            <div className='Program_review_comp'>
              <div className='mt-5 px-5 review_component_text'>
                <h2 className='pt-5 display-6'>Hear What Our Students Say</h2>
                <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
              </div>
            </div>
          </div>
          <div className='col-md-8'>
            <div className='row'>
              {reviews.map((review, index) => (
                <div key={index} className={`col-md-${index % 2 === 0 ? '5' : '7'} card`}>
                  <div className='card-body'>
                    <h5 className='font-weight-bold Review_not_copy'>{review.name}</h5>
                    <h6 className='font-weight-bold my-2 Review_not_copy'>{review.institution}</h6>
                    <ul className='list-unstyled d-flex justify-content-start Review_not_copy'>
                      {[...Array(5)].map((_, i) => (
                        <li key={i}>
                          <FaStar color={i < review.stars ? "gold" : undefined} />
                        </li>
                      ))}
                    </ul>
                    <p className='Review_not_copy'>
                      <i className='fas fa-quote-left pe-2'></i>{review.comment}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BA_Review_Program_Page
